export default __webpack_public_path__ + "static/banner-134b625e9b287ce301270c41c8aa58b5.png";